import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import SubNav from "./SubNav";
import Feature from "./Feature";
import "./category.css";

const clients = [
  {
    id: "eatsinthewest",
    name: "Eats in the West",
    desc:
      "Eats in the West sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    features: [
      {
        id: 1,
        desc:
          "Eats in the West offers great and affordable meals from breakfast till dinner, even at your snack time! Because of Eats in the West delicious food their customers have grown in numbers with that we provided them their own system that will help them monitor their supplies and sales.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555216434/rtds_work/webmosystems/eats-f-1.jpg"
      },
      {
        id: 2,
        desc:
          "While your chefs cook and your waiters serve, you can conveniently monitor Eats in the West anytime anywhere through an overview summary of what’s happening. Navigate and check orders if they are delivered properly.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555219096/rtds_work/webmosystems/eats-f-2-02.png"
      },
      {
        id: 3,
        desc:
          "No need to worry on miscommunication between your kitchen and order takers! The system can conveniently take orders and communicate the order right at your kitchen door! Excited to let your customers taste your new recipe? Just add them on the menu!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555219095/rtds_work/webmosystems/eats-f-3.png"
      }
    ]
  },
  {
    id: "racheenaparis",
    name: "Racheen A Paris",
    desc: "Racheen A Paris",
    features: [
      {
        id: 1,
        desc:
          "What to be radiant and beautiful with no chemicals? Racheen A Paris offers you natural skincare and cosmetic products! With their advance inventory system, they can supervise product production and stocks anywhere at any time!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555244056/rtds_work/webmosystems/RaP-f-1.jpg"
      },
      {
        id: 2,
        desc:
          "Problem with your order? No worries! They can track your orders thru their purchasing system so you can rest assured that your order was taken and will be shipped right at your doorstep!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555244051/rtds_work/webmosystems/rap-f-2.png"
      }
    ]
  },
  {
    id: "bayongbags",
    name: "Bayong Bags",
    desc: "Bayong Bags",
    features: [
      {
        id: 1,
        desc:
          "Bayong Bags USA is an authorized reseller of handcrafted and beautifully painted bayong bags. They track their stocks with their own mobile inventory system made by truly yours!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555235298/rtds_work/webmosystems/bbu-f-1.jpg"
      },
      {
        id: 2,
        desc:
          "At any time they can check their stocks and add products if they got a new design! Selling bayong bags has never been so easy.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555235291/rtds_work/webmosystems/BBU-F-2-02.png"
      }
    ]
  },
  {
    id: "radiantskin",
    name: "Radiant Skin",
    desc: "Radiant Skin",
    features: [
      {
        id: 4,
        desc:
          "Personalize your facial care with Radiant Skin! Radiant Skin gives the best facial care for men and women with that we provided them a system to help them track their customers needs and provide even better services yet!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555228804/rtds_work/webmosystems/RS-f-1.jpg"
      },
      {
        id: 5,
        desc:
          "New client? No need to fil up hassle long information sheets for records. They can automate your account so the next time you visit them they know exactly what’s for you!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555228802/rtds_work/webmosystems/RS-f-2-02.png"
      }
    ]
  },
  {
    id: "washlab",
    name: "Wash Lab",
    desc: "Wash Lab",
    features: [
      {
        id: 6,
        desc:
          "Need your laundry wash? Wash Lab can do it for you especially with their own purchasing system they can now give you a better means to wash your laundry!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555328606/rtds_work/webmosystems/wl-f-1.jpg"
      },
      {
        id: 7,
        desc:
          "Every entry of laundry gets reflected in real time with its task bar where they can monitor which tasks havent been pickedup. Moreover, get rid of wasteful and tedious paper works for receipt!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555328592/rtds_work/webmosystems/wl-f-2.png"
      }
    ]
  },
  {
    id: "jeanasdentistry",
    name: "Jeana's Dentistry",
    desc: "Jeana's Dentistry",
    features: [
      {
        id: 7,
        desc:
          "Jeana’s Dentistry only offers the best of their services now that they have the right technology with it!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555323085/rtds_work/webmosystems/jd-f-1.jpg"
      },
      {
        id: 8,
        desc:
          "No time can be wasted, the system can make sure no patient can be scheduled on the same time. So the patient can rest assured he/she will be served at his/her schedule.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555323088/rtds_work/webmosystems/jd-f-2-02.png"
      }
    ]
  },
  {
    id: "sweetsandtho",
    name: "Sweets and Tho",
    desc: "Sweets and Tho",
    features: [
      {
        id: 9,
        desc:
          "Sweets and Tho offers the most luxurios and delicious sweets ever! Every bite is remarkable and just to serve you better they just had their own purchasing order system.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555323248/rtds_work/webmosystems/sat-f-1.jpg"
      },
      {
        id: 10,
        desc:
          "Taking orders from their customers has never been this cute and easy. With just the right amount of sweetness.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555323100/rtds_work/webmosystems/sat-f-2.jpg"
      },
      {
        id: 11,
        desc:
          "With its inventory management as well, Sweets and Tho can record every ingredient its sweets need so that it reflects right away to its production and inventory.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555323085/rtds_work/webmosystems/sat-f-3.jpg"
      }
    ]
  },
  {
    id: "topwater",
    name: "TOP Water",
    desc: "TOP Water",
    features: [
      {
        id: 12,
        desc:
          "TOP Water gives you the the purest and cleanliest wate! Top of their services and their technology as well. Having to provide them the user friendly purchasing order system ever.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555335238/rtds_work/webmosystems/tw-f-1.jpg"
      },
      {
        id: 13,
        desc:
          "With just a few clicks they can conviniently take orders, have an overview of their their inventory and sales, and check its records.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555335238/rtds_work/webmosystems/tw-f-2.png"
      },
      {
        id: 14,
        desc:
          "Great for monitoring you water station wherever you are! Easy for anyone to learn how to operate it and most importantly perfect for TOP water station.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555335239/rtds_work/webmosystems/tw-f-3.png"
      }
    ]
  },
  {
    id: "shoplefranz",
    name: "Shop le Franz",
    desc: "Shop le Franz",
    features: [
      {
        id: 15,
        desc:
          "Franz is having her wardrobe sale! She can show all her unused brand new stuffs and preloved items for sale with her own catalog.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555396958/rtds_work/webmosystems/slf-f-1.jpg"
      },
      {
        id: 16,
        desc:
          "A product catalog is a detailed list of the inventory of a store. This catalog contains all her for sale products showing its images, descriptions, specifications, price etc.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555396962/rtds_work/webmosystems/slf-f-2.jpg"
      },
      {
        id: 17,
        desc:
          "Each product is described properly and consistently. Even mall price is written so consumers will know what their money's worth!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555405596/rtds_work/webmosystems/slf-f-3.jpg"
      }
    ]
  }
];

class WebSystems extends Component {
  render() {
    const id = this.props.match.params.id;
    const selected = clients.filter((item, i) => item.id === id);
    return (
      <div className="web-systems">
        <div className="banner-container">
          <span className="banner-text">
            Discover our web and mobile systems
          </span>
          <div className="banner">
            <img
              src="https://res.cloudinary.com/doddfudab/image/upload/v1555155161/rtds_work/webmosystems/mockup-cover.png"
              alt="banner"
              className="banner"
            />
          </div>
        </div>
        <SubNav />
        {selected[0] ? (
          <Feature
            data={selected[0] ? selected[0].features : []}
            name={selected[0].name}
            desc={selected[0].desc}
          />
        ) : (
          <Feature
            // text={"Click the icons above to discover more about our creation."}
            data={clients[0] ? clients[0].features : []}
            name={clients[0].name}
            desc={clients[0].desc}
          />
        )}
      </div>
    );
  }
}

export default withRouter(WebSystems);



// WEBPACK FOOTER //
// ./src/components/pages/category/WebSystems.js